
import Toasted from 'vue-toasted';

export default function (Vue) {

  Vue.use(Toasted, {
    // iconPack : 'fontawesome'
  });

  // Options to the toast notification
  let optionsDefault = {
    //icon: 'check_circle',
    action: [
      {
        text: 'x',
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    ],
    duration: 15000
  };

  // Options to the toast notification
  let optionsSuccess = {
    type: 'default',
    // icon: 'check_circle',
    className: 'toast-custom-success',
    action: [
      {
        text: 'x',
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    ],
    duration: 15000
  };

  // Options to the toast notification
  let optionsError = {
    type: 'error',
    // icon: 'error_outline',
    className: 'toast-custom-error',
    action: [
      {
        text: 'x',
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    ],
    duration: 15000
  };

  // Register the toast with the custom message
  Vue.toasted.register('toastDefault', (payload) => {

      // if there is no message passed show default message
      if (!payload.message) {
        return 'Uspešna akcija!'
      }

      // if there is a message show it with the message
      return payload.message
    },
    optionsDefault
  );

  // Register the toast with the custom message
  Vue.toasted.register('toastSuccess', (payload) => {

      // if there is no message passed show default message
      if (!payload.message) {
        return 'Uspešna akcija!'
      }

      // if there is a message show it with the message
      return payload.message
    },
    optionsSuccess
  );

  // Register the toast with the custom message
  Vue.toasted.register('toastError', (payload) => {

      // if there is no message passed show default message
      if (! payload.message) {
        return 'Greška!'
      }

      // if there is a message show it with the message
      return payload.message
    },
    optionsError
  );
}